import { ReactNode } from 'react'
import personIcon from '@/assets/incidents-icons/person.svg'

type IncidentPartyPersonCardProps = {
  displayName: string | null
  emptyLabel: string
  onClick?: () => void
  debtBadge?: ReactNode
}

export const IncidentPartyPersonCard = ({
  displayName,
  emptyLabel,
  onClick,
  debtBadge,
}: IncidentPartyPersonCardProps) => {
  const filled = Boolean(displayName)

  const inner = filled ? (
    <div className="flex items-center gap-4">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary1/15">
        <img src={personIcon} alt="" className="h-7 w-7" />
      </div>
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
        <span className="font-bold text-[#00356b]">{displayName}</span>
        {debtBadge}
      </div>
    </div>
  ) : (
    <p className="text-center text-sm text-[#666]">{emptyLabel}</p>
  )

  const baseClass =
    'w-full rounded-xl p-4 shadow-[0_4px_12px_rgba(0,0,0,0.08)] ' +
    (filled ? 'bg-white' : 'border-2 border-dashed border-primary2/30 bg-white')

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${baseClass} cursor-pointer text-left transition hover:shadow-md`}
      >
        {inner}
      </button>
    )
  }

  return <div className={baseClass}>{inner}</div>
}
